// Bangladesh & global adult height reference statistics.
// Sources: Bangladesh Bureau of Statistics (BBS), WHO Demographic & Health Survey,
// NCD-RisC global pooled analysis (2016).

export type Population = "BD" | "SA" | "GLOBAL";

export interface HeightStats {
  malesMeanCm: number;
  malesSdCm: number;
  femalesMeanCm: number;
  femalesSdCm: number;
  label: { en: string; bn: string };
}

export const POPULATION_STATS: Record<Population, HeightStats> = {
  BD: {
    malesMeanCm: 163.8,
    malesSdCm: 6.0,
    femalesMeanCm: 151.8,
    femalesSdCm: 5.5,
    label: { en: "Bangladesh", bn: "বাংলাদেশ" },
  },
  SA: {
    malesMeanCm: 165.1,
    malesSdCm: 6.5,
    femalesMeanCm: 152.6,
    femalesSdCm: 6.0,
    label: { en: "South Asian", bn: "দক্ষিণ এশীয়" },
  },
  GLOBAL: {
    malesMeanCm: 171.0,
    malesSdCm: 7.4,
    femalesMeanCm: 159.5,
    femalesSdCm: 7.1,
    label: { en: "Global", bn: "বিশ্বব্যাপী" },
  },
};

// WHO child height-for-age 50th percentile (cm) — abbreviated reference.
// Years 2-18, M = boys, F = girls. Used for child growth context only.
export const WHO_CHILD_MEDIAN: Array<{ age: number; M: number; F: number }> = [
  { age: 2, M: 86.4, F: 85.0 },
  { age: 3, M: 95.1, F: 93.9 },
  { age: 4, M: 102.3, F: 101.6 },
  { age: 5, M: 109.2, F: 108.4 },
  { age: 6, M: 115.5, F: 114.6 },
  { age: 7, M: 121.7, F: 120.8 },
  { age: 8, M: 127.3, F: 126.6 },
  { age: 9, M: 132.6, F: 132.5 },
  { age: 10, M: 137.8, F: 138.6 },
  { age: 11, M: 143.1, F: 145.0 },
  { age: 12, M: 149.1, F: 151.2 },
  { age: 13, M: 156.0, F: 156.4 },
  { age: 14, M: 163.2, F: 159.8 },
  { age: 15, M: 169.0, F: 161.7 },
  { age: 16, M: 172.9, F: 162.5 },
  { age: 17, M: 175.2, F: 162.9 },
  { age: 18, M: 176.1, F: 163.0 },
];
